import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
// routes
import { paths } from 'src/routes/paths';
import { useRouter, useParams } from 'src/routes/hook';
// assets
import { countries } from 'src/assets/data';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import Iconify from 'src/components/iconify';
import { enqueueSnackbar, useSnackbar } from 'src/components/snackbar';
import FormProvider, {
  RHFTextField,
  RHFAutocomplete,
  RHFSelect,
} from 'src/components/hook-form';
import { endpoints, getFetcher1, getFetcherPrams, postFetcher, postFetcher1, postPramsFetcher1, putFetcher1 } from 'src/utils/axios';
import 'react-phone-number-input/style.css';
import { MuiTelInput } from 'mui-tel-input';
import { ca } from 'date-fns/locale';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';
import { toDate } from 'date-fns';
import TourGuideSchemaListUI from './tour-guide-schema-list';


// ----------------------------------------------------------------------

export default function TourGuideEditForm({ currentUser, isEditMode }) {
  // Form validation schema
  const TourGuideSchema = Yup.object().shape({
    schema_name: Yup.string().required('Schema Name is required'),
    schema_code: Yup.string().required('Schema Code is required'),
    from: Yup.date().required('From Date is required'),
    to: Yup.date().required('To Date is required'),
  });

  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [sort, setSort] = useState(0);
  const [tableData, setTableData] = useState();
  const [loading, setLoading] = useState(false);
  const [updateId, setUpdateId] = useState(null);
  const [isEnabled, setIsEnabled] = useState(true);
  const [name, setName] = useState("");
  console.log('isEnabled1', isEnabled);

  // Default values for the form
  const defaultValues = useMemo(
    () => ({
      schema_name: currentUser?.schema_name || '',
      schema_code: currentUser?.schema_code || '',
      from: currentUser?.from || '',
      to: currentUser?.to || '',
      isEnabled
    }),
    [currentUser, isEnabled]
  );

  // React Hook Form methods
  const methods = useForm({
    resolver: yupResolver(TourGuideSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  // Simulate loading state
  const loadingSend = useBoolean(false);

  // Determine if editing or creating
  const currentUserDetails = !!currentUser;

  const setNameFromChild = (name1) => {
    console.log('setNameFromChild called with:', name1);

    setName(name1);
  }
  // Handlers for submit actions
  // create api call
  const handleCreateAndSend = handleSubmit(async (data) => {
    console.log('handleCreateAndSend called with data:', data);
    loadingSend.onTrue();
    const payload = {
      id: updateId || null,
      name: data.schema_name,
      code: data.schema_code,
      fromDate: moment(data.from).format('YYYY-MM-DD'),
      toDate: moment(data.to).format('YYYY-MM-DD'),
      isEnabled,
    };

    try {
      const response = (updateId) === null ? await postFetcher1(endpoints.tourGuide.createTourGuide, payload) : await putFetcher1(`${endpoints.tourGuide.createTourGuide}/${updateId}`, payload);
      if (!response || (response.status !== 201 && response.status !== 200)) {
        enqueueSnackbar('Failed to create tour guide schema', {
          variant: 'error',
          autoHideDuration: 5000,
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          sx: {
            width: '400px',
          },
        });
        setIsEnabled(true);
        throw new Error(response?.message || 'Failed to create tour guide schema');

      } else {
        fetchTourGuideSchemas();

        enqueueSnackbar('Tour guide schema created successfully', {
          variant: 'success',
          autoHideDuration: 5000,
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          sx: {
            width: '400px',
          },
        });
        // Reset form if needed
        methods.reset({
          schema_name: '',
          schema_code: '',
          from: '',
          to: '',

        });
      }

      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 1000));
      // Show success message or handle response
    } catch (error) {
      enqueueSnackbar('Failed to create tour guide schema', {
        variant: 'error',
        autoHideDuration: 5000,
        anchorOrigin: { vertical: 'top', horizontal: 'center' },
        sx: {
          width: '400px',
        },
      });
    } finally {
      loadingSend.onFalse();
    }
    setUpdateId(null); // Reset updateId after submission
  });

  const fetchTourGuideSchemas = useCallback(async () => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      setLoading(true);
      const param = {
        name: name || '',
      };
      const response = await postPramsFetcher1(`${endpoints.tourGuide.search}/${page}/${size}/${sort}`, null, param, config);

      if (response && response.status === 200) {
        setTableData(response?.data);
      } else {
        enqueueSnackbar('Failed to fetch tour guide schemas', {
          variant: 'error',
          autoHideDuration: 5000,
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          sx: { width: '400px' },
        });
      }
    } catch (error) {
      enqueueSnackbar('Failed to fetch tour guide schemas', {
        variant: 'error',
        autoHideDuration: 5000,
        anchorOrigin: { vertical: 'top', horizontal: 'center' },
      });
    }
    setLoading(false);

  }, [page, size, sort, name]);
  console.log("namenamename", name);

  const handleEditRowEnable = useCallback(
    async (row, isEnabled2) => {
      console.log('rowFire', row);
      let isEnabled1;
      if (isEnabled2 === true || isEnabled2 === 'true' || isEnabled2 === '1') {
        isEnabled1 = false;
      }
      else {
        isEnabled1 = true;
      }

      try {
        const payload = {
          ...row,
          isEnabled: isEnabled1,
        };
        const response = await putFetcher1(`${endpoints.tourGuide.root}/${row.id}`, payload);
        if (!response || response.status !== 200) {
          enqueueSnackbar('Failed to update tour guide schema', {
            variant: 'error',
            autoHideDuration: 5000,
            anchorOrigin: { vertical: 'top', horizontal: 'center' },
            sx: { width: '400px' },
          });
        } else {
          enqueueSnackbar('Tour guide schema updated successfully', {
            variant: 'success',
            autoHideDuration: 5000,
            anchorOrigin: { vertical: 'top', horizontal: 'center' },
            sx: { width: '400px' },
          });

          fetchTourGuideSchemas();
        }
      } catch (error) {
        enqueueSnackbar('Failed to update tour guide schema', {
          variant: 'error',
          autoHideDuration: 5000,
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          sx: { width: '400px' },
        });
      }

      // const schema = await getFetcher1(endpoints.tourGuide.root(id));
      // if (!schema || schema.status !== 200) {
      //   enqueueSnackbar('Failed to fetch tour guide schema', {
      //     variant: 'error',
      //     autoHideDuration: 5000,
      //     anchorOrigin: { vertical: 'top', horizontal: 'center' },
      //     sx: { width: '400px' },
      //   });
      // } else {
      //   console.log('schema', schema);
      // }


    },
    [fetchTourGuideSchemas]
  );



  useEffect(() => {
    function fetchTourGuideSchemas1() {
      fetchTourGuideSchemas();
    }
    fetchTourGuideSchemas1();
  }, [page, size, sort, fetchTourGuideSchemas]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  // Handler to set the page size
  const handleSizeChange = (newSize) => {
    setSize(newSize);
    // setPage(0); // Optionally reset to first page when size changes
  };


  const handleEditRow = useCallback(
    async (row) => {
      console.log('Editing row:', row);
      methods.setValue('schema_name', row?.name || '');
      methods.setValue('schema_code', row?.code || '');
      methods.setValue('from', row?.fromDate ? new Date(row.fromDate) : null);
      methods.setValue('to', row?.toDate ? new Date(row.toDate) : null);
      setIsEnabled(row?.isEnabled);
      setUpdateId(row?.id || null);
    },
    [methods]
  );

  return (
    <FormProvider methods={methods}>
      <Grid container spacing={3}>
        <Grid xs={12} md={12}>
          <Card sx={{ p: 3 }}>
            <Typography sx={{ mb: 1, fontWeight: 'bold' }}>Schema Details</Typography>
            <Box
              rowGap={3}
              columnGap={2}
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
              }}
              sx={{ mb: 2 }}
            >
              <RHFTextField
                size="small"
                name="schema_name"
                label="Schema Name"
              />
              <RHFTextField
                size="small"
                name="schema_code"
                label="Schema Code"
              />
              <Controller
                name="from"
                control={methods.control}
                render={({ field, fieldState }) => (
                  <DatePicker
                    label="From Date"
                    value={field.value || null}
                    onChange={field.onChange}
                    slotProps={{
                      textField: {
                        size: 'small',
                        error: !!fieldState.error,
                        helperText: fieldState.error?.message,
                      },
                    }}
                  />
                )}
              />
              <Controller
                name="to"
                control={methods.control}
                render={({ field, fieldState }) => (
                  <DatePicker
                    label="To Date"
                    value={field.value || null}
                    onChange={field.onChange}
                    slotProps={{
                      textField: {
                        size: 'small',
                        error: !!fieldState.error,
                        helperText: fieldState.error?.message,
                      },
                    }}
                  />
                )}
              />
            </Box>
            <Stack justifyContent="flex-end" direction="row" spacing={2} sx={{ mt: 2 }}>
              <LoadingButton
                type="submit"
                variant="contained"
                loading={loadingSend.value && isSubmitting}
                onClick={handleCreateAndSend}
              >
                {updateId === null ? 'Create Tour Guide Schema' : 'Update Tour Guide Schema'}
              </LoadingButton>
            </Stack>
          </Card>
          <br />
          <br />
          <TourGuideSchemaListUI
            handlePageChange={handlePageChange}
            handleSizeChange={handleSizeChange}
            tableDataFromParent={tableData}
            handleEditRowParent={handleEditRow}
            handleEditRowEnable={handleEditRowEnable}
            setNameFromChild={setNameFromChild}
            loading={loading}
          />
        </Grid>
      </Grid>
    </FormProvider>
  );
}

TourGuideEditForm.propTypes = {
  currentUser: PropTypes.object,
  isEditMode: PropTypes.bool,
};
